import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { HelpdeskNotificationsAPI } from "../../../../api/helpdeskNotifications";

export default function NotificationsList() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  async function load() {
    const data = await HelpdeskNotificationsAPI.list();
    setNotifications(data.notifications || []);
    setLoading(false);
  }

  useEffect(() => {
    load();
  }, []);

  if (loading) return <div>Loading notifications…</div>;

  return (
    <div className="space-y-4">
      <div className="flex justify-between">
        <h2 className="text-lg font-semibold">Notifications</h2>

        <button
          onClick={() => navigate("/helpdesk/automation/notifications/new")}
          className="px-4 py-2 bg-blue-600 text-white rounded"
        >
          New notification
        </button>
      </div>

      <table className="w-full border">
        <thead>
          <tr className="bg-gray-100">
            <th className="p-2 text-left">Name</th>
            <th className="p-2">Channel</th>
            <th className="p-2">Enabled</th>
            <th className="p-2">Delete</th>
          </tr>
        </thead>

        <tbody>
          {notifications.map((n) => (
            <tr key={n.id} className="border-t hover:bg-gray-50">
              <td
                className="p-2 cursor-pointer text-blue-600"
                onClick={() =>
                  navigate(`/helpdesk/automation/notifications/${n.id}`)
                }
              >
                {n.name}
              </td>

              <td className="p-2 text-center">{n.channel}</td>

              <td className="p-2 text-center">
                {n.enabled ? "Yes" : "No"}
              </td>

              <td className="p-2 text-center">
                <button
                  onClick={async (e) => {
                    e.stopPropagation();

                    if (!window.confirm("Delete this notification?")) return;

                    await HelpdeskNotificationsAPI.delete(n.id);
                    load();
                  }}
                  className="text-red-600"
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}